import { Resource } from "@/types"
import { createResource } from "frappe-ui"
import { computed } from "vue"

const res: Resource<Record<string, any>> & { get: any } = createResource({
  url: "bookings.ui.api.get_all_settings",
  cache: "bookings.ui.api.get_all_settings",
})

function maybeReload() {
  if (!res.fetched && !res.loading && !res.error) {
    res.reload()
  }
}

export function useTheming() {
  maybeReload()
  return computed(() => res.data?.website_theme || {})
}

export function useWebsiteSettings() {
  maybeReload()
  return computed(() => res.data?.website_settings || {})
}

export function usePortalSettings() {
  maybeReload()
  return computed(() => res.data?.bookings_portal_settings || {})
}

// TODO: Reload based on active company?
export function useCartSettings() {
  maybeReload()
  return computed(() => res.data?.cart_settings || {})
}

// First day of the week as an index (0 = Sunday … 6 = Saturday), matching the
// date picker's `week-start` convention. Falls back to Monday.
export function useFirstDayOfWeek() {
  maybeReload()
  return computed(() => res.data?.booking_settings?.first_day_of_week ?? 1)
}

// Opt-in (Booking Settings): Week UOMs book one fixed calendar week, like
// months. When off, they keep the free date-range picker.
export function useFixedCalendarWeeks() {
  maybeReload()
  return computed(() => Boolean(res.data?.booking_settings?.fixed_calendar_weeks))
}

export function hasFeature(key: string) {
  maybeReload()
  return Boolean(res.data?.enabled_features?.[key] || false)
}
